import {
  StrategyStatus as ApiStrategyStatus,
  CovOrderSummaryReply,
  MembershipInvestmentFees,
  MembershipPlanType,
  PublicFund,
  Rating,
  TradingStat,
} from '@/api/schema';
import { LowercaseEnumRecord, Timestamp } from '@/api/types';

export const MembershipDistributionPlanType = Object.fromEntries(
  Object.entries(MembershipPlanType).map(([k, v]) => [k.toLowerCase(), v.toLowerCase()]),
) as LowercaseEnumRecord<typeof MembershipPlanType>;

export const StrategyStatus = Object.fromEntries(
  Object.entries(ApiStrategyStatus).map(([k, v]) => [k.toLowerCase(), v.toLowerCase()]),
) as LowercaseEnumRecord<typeof ApiStrategyStatus>;

export type Trade = Omit<CovOrderSummaryReply, 'openDate' | 'closeData'> & {
  openDate: Timestamp;
  closeDate: Timestamp;
};
export type TradingHistory = Trade[];
export type PublicStrategy = Omit<PublicFund, 'strategyStatus' | 'membershipDistribution'> & {
  strategyStatus: (typeof StrategyStatus)[keyof typeof StrategyStatus];
  membershipDistribution: (Omit<MembershipInvestmentFees, 'planType'> & {
    planType: (typeof MembershipDistributionPlanType)[keyof typeof MembershipDistributionPlanType];
  })[];
};
export type RatingStrategy = Rating;
export type TradedAssets = TradingStat[];
export enum TradedAssetsPeriod {
  MONTH = '30d',
  WEEK = '7d',
  ALL = 'ALL',
}
